import React, { useEffect } from 'react'
import { Button } from 'antd'
import { PhoneOutlined } from '@ant-design/icons'
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '../../reducers'
import { getTelephoneSurveys } from '../../reducers/telephoneSurveys/actions'
import { history } from '../../utils/history'
import { TELEPHONE_SURVEYS_OPERATOR_PATH, USER_ROLE } from '../../utils/enums'
import TelephoneSurveyHistoryList from './components/TelephoneSurveyHistoryList'

const TelephoneSurveys = () => {
	const dispatch = useDispatch()
	const surveys = useSelector((state: RootState) => state.telephoneSurveys.telephoneSurveys)
	const profile = useSelector((state: RootState) => state.profile.profile.data)

	useEffect(() => {
		if (profile?.role === USER_ROLE.PHONE_OPERATOR) {
			history.replace(TELEPHONE_SURVEYS_OPERATOR_PATH)
			return
		}
		dispatch(getTelephoneSurveys({
			limit: 1000,
			page: 1
		}))
	}, [dispatch, profile])

	return (
		<div className={'page-wrapper'} style={{ background: '#f3f4f6', minHeight: '100%', padding: '24px 28px' }}>
			<div style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
				<div style={{
					display: 'flex',
					alignItems: 'flex-start',
					justifyContent: 'space-between',
					gap: 24
				}}
				>
					<div>
						<h1 style={{
							margin: 0, color: '#1f2937', fontSize: 28, lineHeight: '34px', fontWeight: 800
						}}
						>
							Telefonické prieskumy
						</h1>
						<p style={{ margin: '8px 0 0', color: '#6b7280', fontSize: 15 }}>
							Prehľad všetkých vykonaných telefonických prieskumov
						</p>
					</div>
					<Button
						type={'primary'}
						icon={<PhoneOutlined />}
						onClick={() => history.push('/prieskum-spokojnosti/telefonistka')}
						style={{
							height: 58,
							padding: '0 30px',
							borderRadius: 8,
							background: '#337ab7',
							borderColor: '#337ab7',
							fontSize: 16,
							fontWeight: 700,
							boxShadow: 'none'
						}}
					>
						Spustiť rozhranie pre telefonistku
					</Button>
				</div>
				<TelephoneSurveyHistoryList
					data={surveys.tableData}
					loading={surveys.isLoading}
					onDeleted={() => dispatch(getTelephoneSurveys({ limit: 1000, page: 1 }))}
				/>
			</div>
		</div>
	)
}

export default TelephoneSurveys
